import { render, staticRenderFns } from "./concern.vue?vue&type=template&id=3c8d088c&scoped=true&"
import script from "./concern.vue?vue&type=script&lang=js&"
export * from "./concern.vue?vue&type=script&lang=js&"
import style0 from "./concern.vue?vue&type=style&index=0&id=3c8d088c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d088c",
  null
  
)

export default component.exports